"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = createMiddlware;

var _actionTypes = require("./actionTypes");

function createMiddlware(metrics) {
  if (!metrics) {
    throw new TypeError("metrics is required.");
  }

  if ((typeof metrics === "undefined" ? "undefined" : _typeof(metrics)) !== "object") {
    throw new TypeError("metrics must be of type object.");
  }

  if (!metrics.api) {
    throw new Error("api property missing on metrics object.");
  }

  if (typeof metrics.api.pageView !== "function") {
    throw new TypeError("metrics.api.pageView is required and must be a function.");
  }

  if (typeof metrics.api.track !== "function") {
    throw new TypeError("metrics.api.track is required and must be a function.");
  }
  return function () {
    return function (next) {
      return function (action) {
        if ((typeof action === "undefined" ? "undefined" : _typeof(action)) === "object" && (0, _actionTypes.isMetricsAction)(action)) {
          if (action.type === _actionTypes.TRACK_PAGEVIEW) {
            metrics.api.pageView(action.data);
          } else {
            metrics.api.track(action.eventName, action.data);
          }
        }
        return next(action);
      };
    };
  };
}
//# sourceMappingURL=createMiddleware.js.map